import * as React from 'react';

// Mirrors the Cognito user pool policy in
// amplify/backend/auth/labsmarts7f5707287f570728/parameters.json
// (passwordPolicyMinLength + passwordPolicyCharacters). Keep the two in sync.
export const PASSWORD_RULES: string[] = [
  'At least 8 characters',
  'At least 1 uppercase letter (A–Z)',
  'At least 1 lowercase letter (a–z)',
  'At least 1 number (0–9)',
  'At least 1 special character (e.g. ! ? @ # $)',
];

interface PasswordRequirementsProps {
  title?: string;
  /** Extra class, e.g. `ls-auth-field-note` when spliced between form fields. */
  className?: string;
}

export class PasswordRequirements extends React.Component<PasswordRequirementsProps, {}> {
  render() {
    const { title = 'Password requirements', className } = this.props;
    return (
      <div className={className ? `ls-auth-requirements ${className}` : 'ls-auth-requirements'}>
        <div className="ls-auth-requirements-title">{title}</div>
        <ul>
          {PASSWORD_RULES.map(rule => (
            <li key={rule}>{rule}</li>
          ))}
        </ul>
      </div>
    );
  }
}
